import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { LINEAR_STEPPER_BASE_CLASSNAME } from './Constants';
import { createLinearStepper } from './LinearStepper';
createComponents(".".concat(LINEAR_STEPPER_BASE_CLASSNAME), createLinearStepper, NO_PATTERN_BUSINESS_LOGIC);
